const API_BASE = process.env.VUE_APP_API_BASE_URL+"/";

export async function fetchWithAuth(url, options = {}) {
  if (url.startsWith("api/")) {
    url = API_BASE + url.replace(/^api\//, "");
  }

  const defaultOptions = {
    mode: "cors",
    credentials: "include", // ✅ 帶 cookie
    headers: {
      Accept: "application/json",
      ...(options.headers || {}),
    },
  };

  try {
    const response = await fetch(url, { ...defaultOptions, ...options });
    return response;
  } catch (err) {
    throw err;
  }
}
